var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipsisVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.967,
    height: 27.856,
    viewBox: "0 0 6.967 27.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M20682.645,10141.852a3.578,3.578,0,0,1-2.531-2.51,4.542,4.542,0,0,1,0-1.778,3.532,3.532,0,0,1,2.445-2.5,4.475,4.475,0,0,1,2.129.078,3.829,3.829,0,0,1,1.434.953,4.2,4.2,0,0,1,.785,1.464,4.7,4.7,0,0,1,0,1.778,3.536,3.536,0,0,1-2.539,2.515,4.142,4.142,0,0,1-.859.077A4.209,4.209,0,0,1,20682.645,10141.852Zm0-10.449a3.573,3.573,0,0,1-2.531-2.51,4.551,4.551,0,0,1,0-1.78,3.533,3.533,0,0,1,2.445-2.5,4.487,4.487,0,0,1,2.129.077,3.859,3.859,0,0,1,1.434.951,4.259,4.259,0,0,1,.785,1.464,4.705,4.705,0,0,1,0,1.78,3.533,3.533,0,0,1-2.539,2.515,4.018,4.018,0,0,1-.859.076A4.082,4.082,0,0,1,20682.645,10131.4Zm0-10.45a3.572,3.572,0,0,1-2.531-2.509,4.542,4.542,0,0,1,0-1.778,3.526,3.526,0,0,1,2.445-2.5,4.474,4.474,0,0,1,2.129.076,3.84,3.84,0,0,1,1.434.953,4.216,4.216,0,0,1,.785,1.464,4.7,4.7,0,0,1,0,1.779,3.532,3.532,0,0,1-2.539,2.513,4.063,4.063,0,0,1-.859.079A4.129,4.129,0,0,1,20682.645,10120.952Z",
    transform: "translate(-20680.025 -10114.072)",
    fill: "#848484"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisVertical);
export default __webpack_public_path__ + "static/media/Ellipsis-vertical.09d597da8428a828ec9b1ce857b47b8d.svg";
export { ForwardRef as ReactComponent };